

export const frontMatter = {};
export const contentTitle = 'JSONConfiguration';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-api-reference-json-json-configuration-md-7dc.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Fields",
  "id": "fields",
  "level": 2
}, {
  "value": "Example",
  "id": "example",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "jsonconfiguration",
        children: "JSONConfiguration"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["A ", _jsx(_components.code, {
        children: "JSONConfiguration"
      }), " is created from a single plain object. The same object shape is also accepted by ", _jsx(_components.code, {
        children: "JSONConfiguration.merge()"
      }), " and ", _jsx(_components.code, {
        children: "JSONConverter"
      }), "'s ", _jsx(_components.code, {
        children: "configuration"
      }), " and ", _jsx(_components.code, {
        children: "mergeConfiguration()"
      }), " props."]
    }), "\n", _jsx(_components.h2, {
      id: "fields",
      children: "Fields"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "classes"
        }), " - a map of classes available to the JSON class resolver. In deck.gl this is typically ", _jsx(_components.code, {
          children: "Layer"
        }), " and ", _jsx(_components.code, {
          children: "View"
        }), " classes."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "functions"
        }), " - a map of functions available to the JSON function resolver."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "enumerations"
        }), " - a map of enumerations available to the JSON string resolver."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "constants"
        }), " - a map of constants available to the JSON string resolver."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "reactComponents"
        }), " - a map of React components available to the JSON class resolver."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "React"
        }), " - injected React runtime used when resolving ", _jsx(_components.code, {
          children: "reactComponents"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "typeKey"
        }), " - override for the class discriminator key. Defaults to ", _jsx(_components.code, {
          children: "@@type"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "functionKey"
        }), " - override for the function discriminator key. Defaults to ", _jsx(_components.code, {
          children: "@@function"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "convertFunction"
        }), " - hook for converting ", _jsx(_components.code, {
          children: "@@="
        }), " accessor strings into executable functions."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "preProcessClassProps"
        }), " - hook that receives a resolved class/component and its props before instantiation."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "postProcessConvertedJson"
        }), " - hook that receives the fully converted result before it is returned."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "example",
      children: "Example"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import {JSONConfiguration} from '@deck.gl/json';\nimport {MapView} from '@deck.gl/core';\nimport {ScatterplotLayer} from '@deck.gl/layers';\n\nconst configuration = new JSONConfiguration({\n  classes: {MapView, ScatterplotLayer},\n  functions: {\n    scaleRadius: ({value}) => value * 2\n  },\n  postProcessConvertedJson: json => ({\n    ...json,\n    layers: (json.layers || []).filter(Boolean)\n  })\n});\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["See more details in the ", _jsx(_components.code, {
        children: "Configuration Reference"
      }), " section."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

